export const NavData = [
  {
    name: "home",
    link: "/",
    id: 1000,
  },
  {
    name: "Features",
    link: "features",
    id: 1001,
  },
  {
    name: "Resume",
    link: "resume",
    id: 1002,
  },
  {
    name: "Projects",
    link: "project",
    id: 1005,
  },
  {
    name: "Blog",
    link: "blog",
    id: 1003,
  },
  {
    name: "Contacts",
    link: "contacts",
    id: 1004,
  },
];
